import { Injectable, Component, OnInit, ViewChild, Injector, AfterViewInit, Input, Output, EventEmitter, HostBinding } from "@angular/core";
import { AppComponentBase } from "../../services/AppComponentBase";
import { LoginResponse, LoginStatus, FacebookService, InitParams, FBPostComponent  } from 'ngx-facebook';
import { IFaceBookPost } from '../../model/socialMedia.request';
import * as $ from "jquery";
import *  as html2canvas from 'html2canvas';  
import { debug } from "util";
import { ShareProvider, ShareService } from "../../services/share.service";

@Injectable()

@Component({
    selector: "socialMediaIcons",
    template: require('./socialMediaIcons.component.html'),
    styles: [require('./socialMediaIcons.component.css')]
})


export class socialMediaIconsComponent extends AppComponentBase implements OnInit {

    @Output()
    shareClicked = new EventEmitter<string>();
    
    @HostBinding('style.width.px') // for backward compability
    @Input()
    width?: number;

    @Input()
    center = true;

    @Input()
    pointer?: boolean = true;

    constructor(injector: Injector,public shareService: ShareService) {
        super(injector);
    }

    ngOnInit(): void {
       
    }

    public share(e: MouseEvent, shareProvider: string) {
        e.stopPropagation();
        this.shareClicked.emit(shareProvider);
    }
}

